import SmsLoginForm from './sms-login-form.vue'
export default SmsLoginForm
